import { z } from 'zod';

/**
 * Limites de tamanho vindos do padrão BR Code (Manual do BR Code, Bacen).
 *
 * Ficam no schema compartilhado de propósito: a tela de configuração avisa o
 * administrador *antes* de salvar, em vez de o problema aparecer depois como
 * um QR que o banco recusa na frente do cliente.
 */
export const LIMITES_BR_CODE = {
  chave: 77,
  nomeRecebedor: 25,
  cidade: 15,
} as const;

export const updateConfiguracaoClubeInput = z.object({
  nomeClube: z.string().trim().max(255, 'Nome do clube deve ter no máximo 255 caracteres'),
  cnpj: z.string().trim().max(18, 'CNPJ deve ter no máximo 18 caracteres'),
  pixChave: z
    .string()
    .trim()
    .max(LIMITES_BR_CODE.chave, `Chave PIX deve ter no máximo ${LIMITES_BR_CODE.chave} caracteres`),
  pixNomeRecebedor: z
    .string()
    .trim()
    .max(
      LIMITES_BR_CODE.nomeRecebedor,
      `Nome do recebedor deve ter no máximo ${LIMITES_BR_CODE.nomeRecebedor} caracteres`
    ),
  pixCidade: z
    .string()
    .trim()
    .max(LIMITES_BR_CODE.cidade, `Cidade deve ter no máximo ${LIMITES_BR_CODE.cidade} caracteres`),
});

export const configuracaoClubeOutput = updateConfiguracaoClubeInput.extend({
  id: z.string(),
  updatedAt: z.date(),
});

/**
 * A cobrança recebe os **itens do carrinho**, não um total pronto: o servidor
 * recalcula com o mesmo helper que `vendas.create` usa, para o valor do QR e o
 * valor gravado na venda serem necessariamente o mesmo número.
 */
export const gerarPixCobrancaInput = z.object({
  items: z
    .array(
      z.object({
        produtoId: z.string().uuid(),
        quantidade: z.number().int().positive(),
        precoUnitario: z.string().optional(),
      })
    )
    .min(1, 'Informe ao menos um item para gerar a cobrança'),
});

export const pixCobrancaOutput = z.object({
  /** BR Code completo — é isso que vira QR e "copia e cola". */
  payload: z.string(),
  /** Valor cobrado, calculado no servidor. */
  valor: z.string(),
});

export type UpdateConfiguracaoClubeInput = z.infer<typeof updateConfiguracaoClubeInput>;
export type ConfiguracaoClubeOutput = z.infer<typeof configuracaoClubeOutput>;
export type GerarPixCobrancaInput = z.infer<typeof gerarPixCobrancaInput>;
export type PixCobrancaOutput = z.infer<typeof pixCobrancaOutput>;
